import AssignmentIcon from '@mui/icons-material/Assignment';
import CampaignIcon from '@mui/icons-material/Campaign';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import NotificationsIcon from '@mui/icons-material/Notifications';
import ScheduleIcon from '@mui/icons-material/Schedule';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import {type SxProps, type Theme} from '@mui/material/styles';
import {type NotificationDto} from '@onroadvantage/optix-safeandsound-openapi';

type IconPaletteColor = 'primary' | 'warning' | 'error' | 'success' | 'info';

// The dark palette keeps light-mode-grade `main` values (e.g. info.main
// #064C55), which are near-invisible on the dark popover — use the `light`
// variant there instead.
const iconSx =
  (color: IconPaletteColor): SxProps<Theme> =>
  (theme: Theme) => ({
    color:
      theme.palette.mode === 'dark'
        ? theme.palette[color].light
        : theme.palette[color].main,
  });

const NOTIFICATION_ICONS: Record<NotificationDto['type'], JSX.Element> = {
  COURSE_ASSIGNED: <AssignmentIcon sx={iconSx('primary')} />,
  COURSE_DEADLINE_APPROACHING: <ScheduleIcon sx={iconSx('warning')} />,
  COURSE_OVERDUE: <WarningAmberIcon sx={iconSx('error')} />,
  COURSE_COMPLETED: <CheckCircleIcon sx={iconSx('success')} />,
  CERTIFICATE_EARNED: <WorkspacePremiumIcon sx={iconSx('success')} />,
  ANNOUNCEMENT: <CampaignIcon sx={iconSx('info')} />,
};

export const getNotificationIcon = (
  type: NotificationDto['type'],
): JSX.Element => {
  return NOTIFICATION_ICONS[type] ?? <NotificationsIcon color="action" />;
};
